import type { Formatter } from '@/backend/errors/Formatter';
import { indent } from '@/backend/logging/indent';
import { prettyPrint } from '@/backend/logging/prettyPrint';

export function joinAndIndent(
  a: unknown[],
  indentation: string,
  printer: Formatter,
): string {
  return a
    .map((item) => {
      return '\n' + indent(prettyPrint(item, printer), indentation);
    })
    .join('');
}
